import { Stack, SxProps, Typography } from '@mui/material';
import { TextBlock } from 'common/ui/TextBlock';
import { AtsQuestionnaireAnswer } from 'generated-graphql/types';
import { formatToDate } from 'utils/datetime';

const container: SxProps = {
  p: 2,
  backgroundColor: 'customGrey.light'
};

type Props = {
  atsQuestionnaireAnswers: AtsQuestionnaireAnswer[];
  createdAt: string;
};

export const ApplicationForm: React.FC<Props> = ({
  atsQuestionnaireAnswers,
  createdAt
}) => {
  return (
    <Stack sx={container} gap="24px">
      <Stack>
        <TextBlock title="Application form response" variant="field" />
        <Typography
          variant="body2"
          sx={{ color: 'customGrey.dark' }}
        >{`Submitted on ${formatToDate(createdAt)}`}</Typography>
      </Stack>

      <Stack gap="15px">
        {atsQuestionnaireAnswers.map(({ question, answer }, index) => (
          <TextBlock
            key={index}
            title={question}
            subtitle={answer}
            variant="field"
          />
        ))}
      </Stack>
    </Stack>
  );
};
